var _rect, _polygon, _path, _rect2, _path2, _rect3, _path3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 4,
    y1: -525,
    x2: 44,
    y2: -565,
    gradientTransform: "matrix(1 0 0 -1 0 -520)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2214,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5415,
    style: {
      stopColor: "#E5E5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEBEBE"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 2.5,
    fill: "url(#SVGID_1_)",
    stroke: "#464646",
    strokeMiterlimit: 10,
    width: 35,
    height: 45
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.75,
    y1: 1.25,
    x2: 21.25,
    y2: 13.75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#73B4C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1747,
    style: {
      stopColor: "#6AAEC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4567,
    style: {
      stopColor: "#529EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    style: {
      stopColor: "#2C839F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#147391"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_2_)",
    stroke: "#464646",
    strokeMiterlimit: 10,
    points: "20.5,14.5 15,9 9.5,14.5 9.5,0.5 20.5,0.5 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5A5A5A",
    d: "M15.5,42c-0.1,0-0.3-0.1-0.4-0.1l-2.5-2.5l0.7-0.7l2.1,2.1l5.1-6.1l0.8,0.6l-5.5,6.5 C15.8,41.9,15.7,42,15.5,42C15.5,42,15.5,42,15.5,42z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 39,
    fill: "#5A5A5A",
    width: 13,
    height: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5A5A5A",
    d: "M15.5,34c-0.1,0-0.3-0.1-0.4-0.1l-2.5-2.5l0.7-0.7l2.1,2.1l5.1-6.1l0.8,0.6l-5.5,6.5 C15.8,33.9,15.7,34,15.5,34C15.5,34,15.5,34,15.5,34z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 31,
    fill: "#5A5A5A",
    width: 13,
    height: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5A5A5A",
    d: "M15.5,26c-0.1,0-0.3-0.1-0.4-0.1l-2.5-2.5l0.7-0.7l2.1,2.1l5.1-6.1l0.8,0.6l-5.5,6.5 C15.8,25.9,15.7,26,15.5,26C15.5,26,15.5,26,15.5,26z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 23,
    fill: "#5A5A5A",
    width: 13,
    height: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabIcon);
export default __webpack_public_path__ + "static/media/TabIcon.e4b8f7e011189f704f0d3e3653dd3771.svg";
export { ForwardRef as ReactComponent };